import { render, staticRenderFns } from "./company-goods-on-shelves.vue?vue&type=template&id=0e2a5661&"
import script from "./company-goods-on-shelves.vue?vue&type=script&setup=true&lang=js&"
export * from "./company-goods-on-shelves.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./company-goods-on-shelves.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports